import { useEffect } from "react";
import { useState } from "react";
import Col from "react-bootstrap/Col";
import Nav from "react-bootstrap/Nav";
import Row from "react-bootstrap/Row";
import Tab from "react-bootstrap/Tab";
import { useNavigate } from "react-router";
import Slider from "react-slick";
import constant from "../js/constant";
import { ApiPostMethod } from "../js/helper";
import WishlistButton from "../sharemodal/whishlistButton";
import Spinner from "react-bootstrap/Spinner";
import hatchback from "../../image/hatchback.png";
import activehatchback from "../../image/activehatchback.png";
import hactbackv3 from "../../image/hatchback.png";
import sedanv3 from "../../image/sedan.png";
import suvV3 from "../../image/suv.png";
import muvV3 from "../../image/muv.png"

import sedan from "../../image/sedan.png";
import activesedan from "../../image/activesedan.png";
import suv from "../../image/suv.png";
import activesuv from "../../image/activesuv.png";
import mtv from "../../image/mtv.png";
import activemtv from "../../image/activemtv.png";
import "./bodyType.css";
import badge from "../index/inspectbadge.png"
import { Image } from "react-bootstrap";

function BodyType() {
  const navigate = useNavigate();
  const [bodyType, setBodytype] = useState("hatchback");
  const [error, setError] = useState(false);
  const [homeCity, setHomeCity] = useState(
    localStorage.getItem("homeCity" || "pune")
  );
  const [bodyTypeData, setBodyTypeData] = useState([]);
  const userInfo = localStorage.hasOwnProperty("user")
    ? JSON.parse(localStorage.getItem("user"))
    : "";
  const [isLoading, setIsLoading] = useState(false);
  const [activeImage, setActiveImage] = useState("");
  const [inactiveImage, setInactiveImage] = useState("");
  const formData = new FormData();

  const handleTabSelect = async (eventKey) => {
    setBodytype(eventKey);
  };
  useEffect(() => {
    setIsLoading(true);
    try {
      formData.append("city", homeCity);
      formData.append("bodyType", bodyType);
      // console.log("bodytype>>--",bodyType)
      formData.append("userId", userInfo._id);
      let data = formData;
      let url = `${constant.baseurl}viewCarBodyType`;
      ApiPostMethod(url, data).then((response) => {
        // console.log("body-type===",response)
        if (response.error == false) {
          setError(false);
          setBodyTypeData(response.cars);
          // console.log("body-type---", response.cars)
          setIsLoading(false);
        } else {
          setIsLoading(false);
          setError(true);
        }
      });
    } catch (error) {
      alert("somthing went wrong!");
    }
  }, [bodyType]);

  // useEffect(() => {
  //   switch (bodyType) {
  //     case "Hatchback":
  //       setActiveImage(hactbackv3);
  //       // setInactiveImage(hatchback);
  //       break;
  //     case "Sedan":
  //       setActiveImage(sedanv3);
  //       // setInactiveImage(sedan);
  //       break;
  //     case "SUV":
  //       setActiveImage(suvV3);
  //       // setInactiveImage(suv);
  //       break;
  //     case "MUV":
  //       setActiveImage(muvV3);
  //       // setInactiveImage(mtv);
  //       break;
  //     default:
  //       setActiveImage("");
  //       // setInactiveImage("");
  //       break;
  //   }
  // }, [bodyType]);

  const QuickSell = {
    dots: true,
    arrows: false,
    infinite: true,
    loop: true,
    autoplay: true,
    autoplaySpeed: 10000,
    speed: 5000,
    slidesToShow: 4,
    slidesToScroll: 1,
    lazyLoad: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          dots: false,
          infinite:true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
          dots: false,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: false,
        },
      },
    ],
  };

  return (
    <Tab.Container
      id="left-tabs-example"
      activeKey={bodyType}
      onSelect={handleTabSelect}
    >
      <Row>
        <Col lg="12">
          <Nav variant="pills" className="justify-content-center bodyType">
            <Nav.Item className="bodyType_outer">
              <Nav.Link eventKey="hatchback">
                {/* <img
                  src={bodyType == "hatchback" ? activehatchback : hatchback}
                  
                  alt="hatchback"
                  className="tabimg"
                /> */}

                {/* <img src={hactbackv3} className="bodytype_img"/> */}
                <svg xmlns="http://www.w3.org/2000/svg" width="49" height="22" fill="none"><path fill="#fff" fill-rule="evenodd" d="M43.13 16.18c0-2.66-2.259-4.819-5.044-4.819a5.136 5.136 0 0 0-3.784 1.632 4.68 4.68 0 0 0-1.26 3.188c0 .503.08.99.23 1.445.643 1.956 2.555 3.374 4.814 3.374 2.258 0 4.17-1.418 4.813-3.373.15-.457.23-.943.23-1.446Zm-5.044 1.928c1.114 0 2.017-.863 2.017-1.927 0-1.065-.903-1.928-2.017-1.928-1.115 0-2.018.863-2.018 1.928 0 1.064.903 1.927 2.018 1.927Z" clip-rule="evenodd"/><path fill="#fff" d="M22.86 1h-5.35v6.024h16.792l-4.641-3.822c-.455-.374-.933-.72-1.462-.978A12.2 12.2 0 0 0 22.86 1Z"/><path fill="#fff" fill-rule="evenodd" d="M9.544 11.361c-2.786 0-5.045 2.158-5.045 4.82 0 .503.081.99.231 1.445C5.373 19.582 7.285 21 9.544 21c2.258 0 4.17-1.418 4.813-3.373.15-.457.23-.943.23-1.446 0-2.662-2.258-4.82-5.043-4.82Zm.093 6.532c1.027 0 1.859-.795 1.859-1.776 0-.98-.832-1.776-1.859-1.776-1.026 0-1.858.795-1.858 1.776 0 .98.832 1.776 1.858 1.776Z" clip-rule="evenodd"/><path fill="#fff" d="M4.5 16.18c0-2.66 2.258-4.819 5.044-4.819 2.785 0 5.044 2.158 5.044 4.82 0 .503-.081.99-.231 1.445h3.152V7.024H2.271c-.467.873-.994 2.696-1.191 6.87-.097 2.059 1.59 3.732 3.65 3.732a4.62 4.62 0 0 1-.23-1.445ZM2.271 7.024H17.51V1H9.544a6.546 6.546 0 0 0-5.656 3.25L2.271 7.024ZM33.272 17.627a4.618 4.618 0 0 1-.23-1.446 4.68 4.68 0 0 1 1.26-3.188V7.024H17.51v10.602h15.763Z"/><path fill="#fff" d="M38.086 11.361c2.785 0 5.044 2.158 5.044 4.82 0 .503-.081.99-.231 1.445h4.266c.589-.481.835-2.381.835-5.3 0-3.091-8.653-4.82-13.698-5.302v5.969a5.136 5.136 0 0 1 3.784-1.632Z"/><path fill="#fff" d="M40.103 16.18c0 1.065-.903 1.928-2.017 1.928-1.115 0-2.018-.863-2.018-1.927 0-1.065.903-1.928 2.018-1.928 1.114 0 2.017.863 2.017 1.928ZM11.496 16.117c0 .98-.832 1.776-1.859 1.776-1.026 0-1.858-.795-1.858-1.776 0-.98.832-1.776 1.858-1.776 1.027 0 1.859.795 1.859 1.776Z"/><path stroke="#000000" d="M33.272 17.627C33.915 19.581 35.827 21 38.086 21c2.258 0 4.17-1.418 4.813-3.373m-9.627 0a4.618 4.618 0 0 1-.23-1.446 4.68 4.68 0 0 1 1.26-3.188m-1.03 4.633H17.51m-3.152 0c.15-.456.23-.942.23-1.445 0-2.662-2.258-4.82-5.043-4.82-2.786 0-5.045 2.158-5.045 4.82 0 .503.081.99.231 1.445m9.627 0C13.714 19.582 11.802 21 9.544 21c-2.26 0-4.171-1.418-4.814-3.373m9.627 0h3.152m-12.779 0c-2.06 0-3.747-1.674-3.65-3.732.197-4.175.724-5.998 1.191-6.87m32.031 0C39.347 7.505 48 9.234 48 12.324m-13.698-5.3-4.641-3.823c-.455-.374-.933-.72-1.462-.978A12.2 12.2 0 0 0 22.86 1m11.441 6.024H17.51m16.793 0v5.969M48 12.325c0 2.92-.246 4.82-.835 5.302H42.9M48 12.325h-3.279M42.9 17.627c.15-.457.23-.943.23-1.446 0-2.662-2.258-4.82-5.043-4.82a5.136 5.136 0 0 0-3.784 1.632M2.272 7.024h15.237m-15.238 0L3.888 4.25A6.546 6.546 0 0 1 9.544 1m7.965 0h5.352m-5.352 0v6.024m0-6.024H9.544m7.965 0H9.544m7.965 0h5.352m-5.352 6.024v10.602m3.889-7.951h3.53m15.175 6.506c0 1.064-.903 1.927-2.017 1.927-1.115 0-2.018-.863-2.018-1.927 0-1.065.903-1.928 2.018-1.928 1.114 0 2.017.863 2.017 1.928Zm-28.607-.064c0 .98-.832 1.776-1.859 1.776-1.026 0-1.858-.795-1.858-1.776 0-.98.832-1.776 1.858-1.776 1.027 0 1.859.795 1.859 1.776Z"/></svg>
                <h6 className="text-center" style={{fontSize:"0.9rem"}}>Hatchback</h6>
              </Nav.Link>
            </Nav.Item>
            <Nav.Item className="bodyType_outer">
              <Nav.Link eventKey="sedan">
                {/* <img
                  src={bodyType == "sedan" ? activesedan : sedan}
                  alt="sedan"
                  className="tabimg"
                /> */}
                 {/* <img src={sedanv3} className="bodytype_img"/> */}
                 <svg xmlns="http://www.w3.org/2000/svg" width="65" height="32" fill="none"><path fill="#fff" fill-rule="evenodd" d="M53.473 21.595c0-2.874-2.248-5.205-5.02-5.205-1.5 0-2.846.682-3.765 1.762a5.295 5.295 0 0 0-1.255 3.443c0 .544.08 1.069.23 1.562.64 2.111 2.542 3.643 4.79 3.643s4.15-1.532 4.79-3.643a5.38 5.38 0 0 0 .23-1.562Zm-5.02 2.082c1.109 0 2.008-.932 2.008-2.082s-.9-2.082-2.008-2.082c-1.11 0-2.008.932-2.008 2.082s.899 2.082 2.008 2.082Z" clip-rule="evenodd"/><path fill="#fff" d="M12.81 11.706h13.805V5.2H23.25c-3.265 0-6.355 1.532-8.474 4.088l-.056.069c-.782.943-1.456 1.756-1.91 2.349Z"/><path fill="#fff" d="M31.11 5.2h-4.495v6.506h18.073l-7.49-4.735A11.384 11.384 0 0 0 31.11 5.2Z"/><path fill="#fff" fill-rule="evenodd" d="M17.328 16.39c-2.773 0-5.02 2.33-5.02 5.205 0 .544.08 1.069.23 1.562.64 2.111 2.542 3.643 4.79 3.643s4.15-1.532 4.79-3.643a5.38 5.38 0 0 0 .23-1.562c0-2.874-2.247-5.205-5.02-5.205Zm.093 7.054c1.022 0 1.85-.859 1.85-1.918s-.828-1.917-1.85-1.917c-1.021 0-1.85.858-1.85 1.917 0 1.06.829 1.918 1.85 1.918Z" clip-rule="evenodd"/><path fill="#fff" d="M12.308 21.595c0-2.874 2.247-5.205 5.02-5.205 2.773 0 5.02 2.33 5.02 5.205a5.38 5.38 0 0 1-.23 1.562h4.497V11.706H10.01c-2.313 0-3.866 1.676-4.188 3.98L5.5 18.849c0 2.38 1.875 4.308 4.188 4.308h2.85a5.38 5.38 0 0 1-.23-1.562ZM48.453 16.39c2.772 0 5.02 2.33 5.02 5.205a5.38 5.38 0 0 1-.23 1.562h4.246c.586-.52 1.807-2.395 2.008-5.726.2-3.33-9.79-5.205-14.81-5.725v6.446c.92-1.08 2.266-1.762 3.766-1.762Z"/><path fill="#fff" d="M19.27 21.526c0 1.06-.827 1.918-1.849 1.918-1.021 0-1.85-.859-1.85-1.918s.829-1.917 1.85-1.917c1.022 0 1.85.858 1.85 1.917ZM50.46 21.595c0 1.15-.898 2.082-2.007 2.082-1.11 0-2.008-.932-2.008-2.082s.899-2.082 2.008-2.082 2.008.932 2.008 2.082ZM43.662 23.157a5.38 5.38 0 0 1-.23-1.562c0-1.32.475-2.525 1.256-3.443v-6.446H26.615v11.45h17.047Z"/><path stroke="#000000" d="M43.662 23.157c.64 2.111 2.543 3.643 4.79 3.643 2.249 0 4.151-1.532 4.791-3.643m-9.58 0a5.38 5.38 0 0 1-.23-1.562c0-1.32.474-2.525 1.255-3.443m-1.026 5.005H26.615m-4.497 0a5.38 5.38 0 0 0 .23-1.562c0-2.874-2.247-5.205-5.02-5.205-2.773 0-5.02 2.33-5.02 5.205 0 .544.08 1.069.23 1.562m9.58 0c-.64 2.111-2.542 3.643-4.79 3.643s-4.15-1.532-4.79-3.643m9.58 0h4.497m-14.077 0h-2.85c-2.313 0-4.188-1.929-4.188-4.308l.321-3.163c.322-2.304 1.875-3.98 4.188-3.98h2.8m31.879 0c5.02.52 15.01 2.394 14.809 5.725m-14.81-5.725-7.489-4.735A11.384 11.384 0 0 0 31.11 5.2m13.578 6.506H26.615m18.073 0v6.446m14.809-.72c-.2 3.33-1.422 5.204-2.008 5.725h-4.246m6.254-5.726h-3.263m-2.99 5.726a5.38 5.38 0 0 0 .229-1.562c0-2.874-2.248-5.205-5.02-5.205-1.5 0-2.846.682-3.765 1.762M12.81 11.706h13.805m-13.805 0c.454-.593 1.128-1.406 1.91-2.35M26.614 5.2h4.495m-4.495 0v6.506m0-6.506H23.25m3.365 0H23.25m3.365 0h4.495m-4.495 6.506v11.45m2.51-8.587h3.514m-17.863-5.28C16.896 6.731 19.985 5.2 23.25 5.2m-8.474 4.088-.056.069m.056-.069-.056.069m35.74 12.238c0 1.15-.898 2.082-2.007 2.082-1.11 0-2.008-.932-2.008-2.082s.899-2.082 2.008-2.082 2.008.932 2.008 2.082Zm-31.19-.069c0 1.06-.827 1.918-1.849 1.918-1.021 0-1.85-.859-1.85-1.918s.829-1.917 1.85-1.917c1.022 0 1.85.858 1.85 1.917Z"/></svg>
                <h6 className="text-center" style={{fontSize:"0.9rem"}}>Sedan</h6>
              </Nav.Link>
            </Nav.Item>
            <Nav.Item className="bodyType_outer">
              <Nav.Link eventKey="suv">
                {/* <img
                  src={bodyType == "suv" ? activesuv : suv}
                  alt="suv"
                  className="tabimg"
                /> */}
                 {/* <img src={suvV3} className="bodytype_img"/> */}

<svg xmlns="http://www.w3.org/2000/svg" width="63" height="30" fill="none"><g clip-path="url(#a)"><path fill="#fff" fill-rule="evenodd" d="M56.32 23.298c0-2.945-2.403-5.332-5.367-5.332a5.368 5.368 0 0 0-4.025 1.805 5.294 5.294 0 0 0-1.341 3.527c0 .558.086 1.095.245 1.6a5.365 5.365 0 0 0 5.121 3.733 5.365 5.365 0 0 0 5.12-3.733c.16-.505.246-1.042.246-1.6Zm-5.367 2.134a2.14 2.14 0 0 0 2.147-2.134 2.14 2.14 0 0 0-2.147-2.133 2.14 2.14 0 0 0-2.146 2.133 2.14 2.14 0 0 0 2.146 2.134Z" clip-rule="evenodd"/><path fill="#fff" d="M34.757 6.5h-4.693v7.666h16.864l-4.681-4.837c-.652-.673-1.377-1.284-2.228-1.676A12.57 12.57 0 0 0 34.757 6.5Z"/><path fill="#fff" fill-rule="evenodd" d="M15.589 17.965c-2.964 0-5.366 2.388-5.366 5.333 0 .558.086 1.095.245 1.6a5.365 5.365 0 0 0 5.12 3.733 5.365 5.365 0 0 0 5.121-3.733c.16-.505.246-1.042.246-1.6 0-2.945-2.402-5.332-5.366-5.332Zm.1 7.228c1.091 0 1.977-.88 1.977-1.965a1.971 1.971 0 0 0-1.978-1.965c-1.092 0-1.977.88-1.977 1.965s.885 1.965 1.977 1.965Z" clip-rule="evenodd"/><path fill="#fff" d="M10.223 23.298c0-2.945 2.403-5.332 5.366-5.332 2.964 0 5.367 2.387 5.367 5.332 0 .558-.086 1.095-.246 1.6h9.354V14.166H7c-.5.972-.52 2.369-.509 6.793.006 2.174 1.803 3.94 3.977 3.94a5.301 5.301 0 0 1-.246-1.6ZM7 14.166H30.063V6.5H15.589a7.058 7.058 0 0 0-6.057 3.434L7 14.166ZM45.833 24.898a5.301 5.301 0 0 1-.246-1.6c0-1.352.507-2.587 1.341-3.527v-5.605H30.064v10.732h15.769ZM50.952 17.965c2.964 0 5.367 2.388 5.367 5.333 0 .558-.086 1.095-.246 1.6h4.539c.626-.533.888-2.635.888-5.866 0-3.42-9.206-4.333-14.572-4.866v5.605a5.368 5.368 0 0 1 4.024-1.806Z"/><path fill="#fff" d="M53.1 23.298a2.14 2.14 0 0 1-2.147 2.134 2.14 2.14 0 0 1-2.146-2.134 2.14 2.14 0 0 1 2.146-2.133 2.14 2.14 0 0 1 2.147 2.133ZM17.665 23.228a1.971 1.971 0 0 1-1.977 1.965 1.971 1.971 0 0 1-1.977-1.965c0-1.085.885-1.965 1.977-1.965s1.977.88 1.977 1.965Z"/><path stroke="#000000" d="M15.59 17.965c-2.964 0-5.367 2.388-5.367 5.333 0 .558.086 1.095.246 1.6m5.12-6.933c2.964 0 5.367 2.388 5.367 5.333 0 .558-.086 1.095-.246 1.6m-5.12-6.933v-3.799m-5.121 10.732a5.365 5.365 0 0 0 5.12 3.733 5.365 5.365 0 0 0 5.121-3.733m-10.241 0c-2.174 0-3.97-1.765-3.977-3.939-.012-4.424.008-5.821.509-6.793m13.71 10.732h9.353M15.589 14.166H7.002m8.588 0h14.475m-14.475 0V6.5m30.244 18.398a5.365 5.365 0 0 0 5.12 3.733 5.365 5.365 0 0 0 5.12-3.733m-10.24 0a5.301 5.301 0 0 1-.246-1.6c0-1.352.507-2.587 1.341-3.527m-1.095 5.127h-15.77m26.01 0h4.54c.626-.533.888-2.635.888-5.866m-5.427 5.866c.16-.505.245-1.042.245-1.6 0-2.945-2.402-5.332-5.366-5.332a5.368 5.368 0 0 0-4.025 1.805m0 0v-5.605M30.064 24.898V14.166M7 14.166l2.532-4.232A7.058 7.058 0 0 1 15.589 6.5m31.34 7.666c5.366.533 14.572 1.447 14.572 4.866m-14.572-4.866-4.682-4.837c-.652-.673-1.377-1.284-2.228-1.676A12.57 12.57 0 0 0 34.757 6.5m12.172 7.666H30.063m31.438 4.866h-3.488M34.757 6.5h-4.693m4.693 0h-4.693m0 7.666V6.5m-14.475 0h14.475m-14.475 0h14.475m3.136 9.6h3.756M53.1 23.297a2.14 2.14 0 0 1-2.147 2.134 2.14 2.14 0 0 1-2.146-2.134 2.14 2.14 0 0 1 2.146-2.133 2.14 2.14 0 0 1 2.147 2.133Zm-35.434-.07a1.971 1.971 0 0 1-1.977 1.965 1.971 1.971 0 0 1-1.977-1.965c0-1.085.885-1.965 1.977-1.965s1.977.88 1.977 1.965Z"/><path fill="#fff" stroke="#000000" d="M6.5 15a2.5 2.5 0 0 0-5 0v6a2.5 2.5 0 0 0 5 0v-6ZM37.5 5.5v-3a1 1 0 0 0-1-1h-22a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h22a1 1 0 0 0 1-1Z"/></g><defs><clipPath id="a"><path fill="#fff" d="M.5.5h62v29H.5z"/></clipPath></defs></svg>


                <h6 className="text-center" style={{fontSize:"0.9rem"}}>SUV</h6>
              </Nav.Link>
            </Nav.Item>
            <Nav.Item className="bodyType_outer">
              <Nav.Link eventKey="muv">
                {/* <img
                  src={bodyType == "muv" ? activemtv : mtv}
                  alt="mtv"
                  className="tabimg"
                /> */}
                <svg xmlns="http://www.w3.org/2000/svg" width="57" height="26" fill="none"><path fill="#fff" fill-rule="evenodd" d="M50.824 19.233c0-2.945-2.402-5.333-5.366-5.333a5.368 5.368 0 0 0-4.025 1.805 5.294 5.294 0 0 0-1.341 3.528 5.3 5.3 0 0 0 .245 1.6 5.365 5.365 0 0 0 5.121 3.733 5.365 5.365 0 0 0 5.12-3.733 5.3 5.3 0 0 0 .246-1.6Zm-5.366 2.133a2.14 2.14 0 0 0 2.147-2.133 2.14 2.14 0 0 0-2.147-2.133 2.14 2.14 0 0 0-2.146 2.133 2.14 2.14 0 0 0 2.146 2.133Z" clip-rule="evenodd"/><path fill="#fff" d="M29.261 1.434h-4.693V9.1h16.865l-4.681-4.836c-.652-.674-1.377-1.284-2.229-1.677a12.57 12.57 0 0 0-5.262-1.153Z"/><path fill="#fff" fill-rule="evenodd" d="M10.094 13.9c-2.963 0-5.366 2.388-5.366 5.333a5.3 5.3 0 0 0 .246 1.6 5.365 5.365 0 0 0 5.12 3.733 5.365 5.365 0 0 0 5.12-3.733 5.3 5.3 0 0 0 .247-1.6c0-2.945-2.403-5.333-5.367-5.333Zm.1 7.227c1.092 0 1.977-.88 1.977-1.965a1.971 1.971 0 0 0-1.977-1.964c-1.092 0-1.977.88-1.977 1.964 0 1.085.885 1.965 1.977 1.965Z" clip-rule="evenodd"/><path fill="#fff" d="M4.728 19.233c0-2.945 2.403-5.333 5.366-5.333 2.964 0 5.367 2.388 5.367 5.333a5.3 5.3 0 0 1-.246 1.6h9.353V9.1H1.505c-.503.98-.52 3.04-.507 7.795.005 2.174 1.802 3.938 3.976 3.938a5.3 5.3 0 0 1-.246-1.6ZM1.505 9.1H24.568V1.434H10.094a7.058 7.058 0 0 0-6.056 3.434L1.505 9.1ZM40.337 20.833a5.3 5.3 0 0 1-.245-1.6c0-1.353.507-2.588 1.341-3.528V9.1H24.568v11.733h15.77ZM45.458 13.9c2.964 0 5.366 2.388 5.366 5.333a5.3 5.3 0 0 1-.245 1.6h4.538c.626-.534.888-2.636.888-5.866 0-3.42-9.205-5.333-14.572-5.867v6.605a5.368 5.368 0 0 1 4.025-1.805Z"/><path fill="#fff" d="M47.605 19.233a2.14 2.14 0 0 1-2.147 2.133 2.14 2.14 0 0 1-2.146-2.133 2.14 2.14 0 0 1 2.146-2.133 2.14 2.14 0 0 1 2.147 2.133ZM12.171 19.162a1.971 1.971 0 0 1-1.977 1.965 1.971 1.971 0 0 1-1.977-1.965c0-1.085.885-1.964 1.977-1.964s1.977.88 1.977 1.964Z"/><path stroke="#000000" d="M10.094 13.9c-2.963 0-5.366 2.388-5.366 5.333a5.3 5.3 0 0 0 .246 1.6m5.12-6.933c2.964 0 5.367 2.388 5.367 5.333a5.3 5.3 0 0 1-.246 1.6m-5.12-6.933V9.1m30.242 11.733a5.365 5.365 0 0 0 5.121 3.733 5.365 5.365 0 0 0 5.12-3.733m-10.24 0a5.3 5.3 0 0 1-.246-1.6c0-1.353.507-2.588 1.341-3.528m-1.096 5.128H24.569m-9.353 0a5.365 5.365 0 0 1-5.12 3.733 5.365 5.365 0 0 1-5.121-3.733m10.24 0h9.354m-19.594 0c-2.174 0-3.97-1.764-3.976-3.938-.013-4.756.004-6.815.507-7.795m39.928 0c5.367.534 14.572 2.447 14.572 5.867M41.433 9.1l-4.681-4.836c-.652-.674-1.377-1.284-2.229-1.677a12.57 12.57 0 0 0-5.262-1.153M41.433 9.1H24.568m16.865 0v6.605m14.572-.739c0 3.231-.262 5.333-.888 5.867H50.58m5.426-5.866h-3.488m-1.938 5.866a5.3 5.3 0 0 0 .245-1.6c0-2.945-2.402-5.333-5.366-5.333a5.368 5.368 0 0 0-4.025 1.805M1.505 9.1l2.533-4.232a7.058 7.058 0 0 1 6.056-3.434M1.505 9.1h8.59m14.473-7.666h4.693m-4.693 0V9.1m0-7.666H10.094m14.474 0H10.094m14.474 0h4.693M24.568 9.1v11.733m0-11.733H10.094m17.611 2.934h3.756m-21.367-10.6V9.1m37.51 10.133a2.14 2.14 0 0 1-2.146 2.133 2.14 2.14 0 0 1-2.146-2.133 2.14 2.14 0 0 1 2.146-2.133 2.14 2.14 0 0 1 2.147 2.133Zm-35.433-.07a1.971 1.971 0 0 1-1.977 1.964 1.971 1.971 0 0 1-1.977-1.965c0-1.085.885-1.964 1.977-1.964s1.977.88 1.977 1.964Z"/></svg>
                 {/* <img src={muvV3} className="bodytype_img"/> */}

                <h6 className="text-center" style={{fontSize:"0.9rem"}}>MUV</h6>
              </Nav.Link>
            </Nav.Item>
          </Nav>
        </Col>
        <Col sm={12}>
          <Tab.Content>
            <Tab.Pane eventKey="hatchback" className="p-3 body_tab">
              {isLoading ? (
                <div className="text-center">
                  <Spinner animation="border" variant="danger" />
                </div>
              ) : (
                <Slider {...QuickSell}>
                  {error == false ? (
                    bodyTypeData.map((postedcar, index) => (
                      <div key={index}>
                        <div className="carousel-slide quick-sell-slide">
                          <div className="col-12 car-details quick-car " style={{overflow:"hidden",position:"relative"}}>
                          {
                            postedcar.carDetails.city === 'pune'?
                            <div className="inspected_badge" >
                             <div>
                              {/* <FaAward/> */}
                              <Image src={badge} style={{height:"22px"}}/>
                              </div> </div>: ""
                            }
                            <img
                              src={postedcar.carDetails.carImages[0]}
                              alt=""
                              onClick={() =>
                                navigate(
                                  "/SingleCarDetail?carPostId=" +
                                    postedcar.carDetails._id
                                )
                              }
                            />
                            <Col lg="12" className="details">
                              <Col
                                lg="12"
                                className="d-flex justify-content-between"
                              >
                                <Col
                                  lg="10"
                                  onClick={() =>
                                    navigate(
                                      "/SingleCarDetail?carPostId=" +
                                        postedcar.carDetails._id
                                    )
                                  }
                                >
                                  <h5 className="mb-1 body_h5">
                                    {postedcar.carDetails.brandId}{" "}
                                    {postedcar.carDetails.year}
                                  </h5>
                                  <h6 className="mb-2 body_h6">
  {`${postedcar.carDetails.model} ${postedcar.carDetails.varient} - ${
    postedcar.carDetails.carNumber
      ? postedcar.carDetails.carNumber.replace(/\s/g, "").substring(0, 4)
      : ""
  }`.substring(0, 20)}
  {`${postedcar.carDetails.model} ${postedcar.carDetails.varient} - ${
    postedcar.carDetails.carNumber
      ? postedcar.carDetails.carNumber.replace(/\s/g, "").substring(0, 4)
      : ""
  }`.length > 20 ? "..." : ""}
</h6>
                                </Col>
                                <Col
                                  lg="1"
                                  className={
                                    localStorage.hasOwnProperty("user")
                                      ? ""
                                      : "d-none"
                                  }
                                >
                                  <WishlistButton
                                    wishlist={postedcar.wishlisted}
                                    uPostId={postedcar.carDetails._id}
                                    userId={userInfo._id}
                                  />
                                </Col>
                              </Col>
                              <Col lg="12">
                                <h6 style={{textTransform:"capitalize"}}>
                                  {(
                                    postedcar.carDetails.kms / 1000
                                  ).toLocaleString("en-US", {
                                    maximumFractionDigits: 1,
                                  }) + "k"}{" "}
                                  km{" "}
                                  <span>
                                    <svg
                                      width="5"
                                      height="5"
                                      viewBox="0 0 5 5"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <circle
                                        cx="2.5"
                                        cy="2.5"
                                        r="2.5"
                                        fill="black"
                                      />
                                    </svg>
                                  </span>{" "}
                                  <span className="text-capitalize">
                                    {postedcar.fuelType}
                                  </span>{" "}
                                  <span>
                                    <svg
                                      width="5"
                                      height="5"
                                      viewBox="0 0 5 5"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <circle
                                        cx="2.5"
                                        cy="2.5"
                                        r="2.5"
                                        fill="black"
                                      />
                                    </svg>
                                  </span>{" "}
                                  {postedcar.carDetails.transmission}
                                </h6>
                              </Col>
                            </Col>
                            <Col lg="12" className="p-2">
                              <svg
                                width="21"
                                height="21"
                                viewBox="0 0 21 21"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <g clip-path="url(#clip0_434_2834)">
                                  <path
                                    d="M18.3814 8.46854C18.3814 14.3784 10.783 19.444 10.783 19.444C10.783 19.444 3.18457 14.3784 3.18457 8.46854C3.18457 6.45331 3.98512 4.52062 5.4101 3.09564C6.83508 1.67066 8.76777 0.870117 10.783 0.870117C12.7982 0.870117 14.7309 1.67066 16.1559 3.09564C17.5809 4.52062 18.3814 6.45331 18.3814 8.46854Z"
                                    stroke="#333333"
                                    stroke-width="1.71704"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  />
                                  <path
                                    d="M10.7828 11.0014C12.1816 11.0014 13.3156 9.86743 13.3156 8.4686C13.3156 7.06977 12.1816 5.93579 10.7828 5.93579C9.38398 5.93579 8.25 7.06977 8.25 8.4686C8.25 9.86743 9.38398 11.0014 10.7828 11.0014Z"
                                    stroke="#333333"
                                    stroke-width="1.71704"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  />
                                </g>
                                <defs>
                                  <clipPath id="clip0_434_2834">
                                    <rect
                                      width="20.2625"
                                      height="20.2625"
                                      fill="white"
                                      transform="translate(0.651611 0.026001)"
                                    />
                                  </clipPath>
                                </defs>
                              </svg>
                              <span className="m-1" style={{textTransform:"capitalize"}}>Cars 2 Cars Hub, {postedcar.carDetails.city}</span>
                            </Col>
                          </div>
                        </div>
                      </div>
                    ))
                  ) : (
                    <h5 className="text-color text-center m-0 mt-2">
                      Cars Not Found
                    </h5>
                  )}
                </Slider>
              )}
            </Tab.Pane>
            <Tab.Pane eventKey="sedan" className="p-3 body_tab">
              {isLoading ? (
                <div className="text-center">
                  <Spinner animation="border" variant="danger" />
                </div>
              ) : (
                <Slider {...QuickSell}>
                  {error == false ? (
                    bodyTypeData.map((postedcar, index) => (
                      <div key={index}>
                        <div className="carousel-slide quick-sell-slide">
                          <div className="col-12 car-details quick-car"  style={{overflow:"hidden",position:"relative"}}>
                          {
                            postedcar.carDetails.city === 'pune'?
                            <div className="inspected_badge" >
                             <div>
                              {/* <FaAward/> */}
                              <Image src={badge} style={{height:"22px"}}/>
                              </div> </div>: ""
                            }
                            <img
                              src={postedcar.carDetails.carImages[0]}
                              alt=""
                              onClick={() =>
                                navigate(
                                  "/SingleCarDetail?carPostId=" +
                                    postedcar.carDetails._id
                                )
                              }
                            />
                            <Col lg="12" className="details">
                              <Col
                                lg="12"
                                className="d-flex justify-content-between"
                              >
                                <Col
                                  lg="10"
                                  onClick={() =>
                                    navigate(
                                      "/SingleCarDetail?carPostId=" +
                                        postedcar.carDetails._id
                                    )
                                  }
                                >
                                  <h5 className="mb-1 body_h5">
                                    {postedcar.carDetails.brandId}{" "}
                                    {postedcar.carDetails.year}
                                  </h5>
                                  <h6 className="mb-2 body_h6">
  {`${postedcar.carDetails.model} ${postedcar.carDetails.varient} - ${
    postedcar.carDetails.carNumber
      ? postedcar.carDetails.carNumber.replace(/\s/g, "").substring(0, 4)
      : ""
  }`.substring(0, 20)}
  {`${postedcar.carDetails.model} ${postedcar.carDetails.varient} - ${
    postedcar.carDetails.carNumber
      ? postedcar.carDetails.carNumber.replace(/\s/g, "").substring(0, 4)
      : ""
  }`.length > 20 ? "..." : ""}
</h6>
                                </Col>
                                <Col
                                  lg="1"
                                  className={
                                    localStorage.hasOwnProperty("user")
                                      ? ""
                                      : "d-none"
                                  }
                                >
                                  <WishlistButton
                                    wishlist={postedcar.wishlisted}
                                    uPostId={postedcar.carDetails._id}
                                    userId={userInfo._id}
                                  />
                                </Col>
                              </Col>
                              <Col lg="12">
                                <h6 style={{textTransform:"capitalize"}}>
                                  {(
                                    postedcar.carDetails.kms / 1000
                                  ).toLocaleString("en-US", {
                                    maximumFractionDigits: 1,
                                  }) + "k"}{" "}
                                  km{" "}
                                  <span>
                                    <svg
                                      width="5"
                                      height="5"
                                      viewBox="0 0 5 5"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <circle
                                        cx="2.5"
                                        cy="2.5"
                                        r="2.5"
                                        fill="black"
                                      />
                                    </svg>
                                  </span>{" "}
                                  <span className="text-capitalize">
                                    {postedcar.fuelType}
                                  </span>{" "}
                                  <span>
                                    <svg
                                      width="5"
                                      height="5"
                                      viewBox="0 0 5 5"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <circle
                                        cx="2.5"
                                        cy="2.5"
                                        r="2.5"
                                        fill="black"
                                      />
                                    </svg>
                                  </span>{" "}
                                  {postedcar.carDetails.transmission}
                                </h6>
                              </Col>
                            </Col>
                            <Col lg="12" className="p-2">
                              <svg
                                width="21"
                                height="21"
                                viewBox="0 0 21 21"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <g clip-path="url(#clip0_434_2834)">
                                  <path
                                    d="M18.3814 8.46854C18.3814 14.3784 10.783 19.444 10.783 19.444C10.783 19.444 3.18457 14.3784 3.18457 8.46854C3.18457 6.45331 3.98512 4.52062 5.4101 3.09564C6.83508 1.67066 8.76777 0.870117 10.783 0.870117C12.7982 0.870117 14.7309 1.67066 16.1559 3.09564C17.5809 4.52062 18.3814 6.45331 18.3814 8.46854Z"
                                    stroke="#333333"
                                    stroke-width="1.71704"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  />
                                  <path
                                    d="M10.7828 11.0014C12.1816 11.0014 13.3156 9.86743 13.3156 8.4686C13.3156 7.06977 12.1816 5.93579 10.7828 5.93579C9.38398 5.93579 8.25 7.06977 8.25 8.4686C8.25 9.86743 9.38398 11.0014 10.7828 11.0014Z"
                                    stroke="#333333"
                                    stroke-width="1.71704"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  />
                                </g>
                                <defs>
                                  <clipPath id="clip0_434_2834">
                                    <rect
                                      width="20.2625"
                                      height="20.2625"
                                      fill="white"
                                      transform="translate(0.651611 0.026001)"
                                    />
                                  </clipPath>
                                </defs>
                              </svg>
                              <span className="m-1" style={{textTransform:"capitalize"}}>Cars 2 Cars Hub, {postedcar.carDetails.city}</span>
                            </Col>
                          </div>
                        </div>
                      </div>
                    ))
                  ) : (
                    <h5 className="text-color text-center m-0 mt-2">
                      Cars Not Found
                    </h5>
                  )}
                </Slider>
              )}
            </Tab.Pane>
            <Tab.Pane eventKey="suv" className="p-3 body_tab">
              {isLoading ? (
                <div className="text-center">
                  <Spinner animation="border" variant="danger" />
                </div>
              ) : (
                <Slider {...QuickSell}>
                  {error == false ? (
                    bodyTypeData.map((postedcar, index) => (
                      <div key={index}>
                        <div className="carousel-slide quick-sell-slide">
                          <div className="col-12 car-details quick-car"  style={{overflow:"hidden",position:"relative"}}>
                          {
                            postedcar.carDetails.city === 'pune'?
                            <div className="inspected_badge" >
                             <div>
                              {/* <FaAward/> */}
                              <Image src={badge} style={{height:"22px"}}/>
                              </div> </div>: ""
                            }
                            <img
                              src={postedcar.carDetails.carImages[0]}
                              alt=""
                              onClick={() =>
                                navigate(
                                  "/SingleCarDetail?carPostId=" +
                                    postedcar.carDetails._id
                                )
                              }
                            />
                            <Col lg="12" className="details">
                              <Col
                                lg="12"
                                className="d-flex justify-content-between"
                              >
                                <Col
                                  lg="10"
                                  onClick={() =>
                                    navigate(
                                      "/SingleCarDetail?carPostId=" +
                                        postedcar.carDetails._id
                                    )
                                  }
                                >
                                  <h5 className="mb-1">
                                    {postedcar.carDetails.brandId}{" "}
                                    {postedcar.carDetails.year}
                                  </h5>
                                  <h6 className="mb-2">
  {`${postedcar.carDetails.model} ${postedcar.carDetails.varient} - ${
    postedcar.carDetails.carNumber
      ? postedcar.carDetails.carNumber.replace(/\s/g, "").substring(0, 4)
      : ""
  }`.substring(0, 20)}
  {`${postedcar.carDetails.model} ${postedcar.carDetails.varient} - ${
    postedcar.carDetails.carNumber
      ? postedcar.carDetails.carNumber.replace(/\s/g, "").substring(0, 4)
      : ""
  }`.length > 20 ? "..." : ""}
</h6>
                                </Col>
                                <Col
                                  lg="1"
                                  className={
                                    localStorage.hasOwnProperty("user")
                                      ? ""
                                      : "d-none"
                                  }
                                >
                                  <WishlistButton
                                    wishlist={postedcar.wishlisted}
                                    uPostId={postedcar.carDetails._id}
                                    userId={userInfo._id}
                                  />
                                </Col>
                              </Col>
                              <Col lg="12">
                                <h6 style={{textTransform:"capitalize"}}>
                                  {(
                                    postedcar.carDetails.kms / 1000
                                  ).toLocaleString("en-US", {
                                    maximumFractionDigits: 1,
                                  }) + "k"}{" "}
                                  km{" "}
                                  <span>
                                    <svg
                                      width="5"
                                      height="5"
                                      viewBox="0 0 5 5"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <circle
                                        cx="2.5"
                                        cy="2.5"
                                        r="2.5"
                                        fill="black"
                                      />
                                    </svg>
                                  </span>{" "}
                                  <span className="text-capitalize">
                                    {postedcar.fuelType}
                                  </span>{" "}
                                  <span>
                                    <svg
                                      width="5"
                                      height="5"
                                      viewBox="0 0 5 5"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <circle
                                        cx="2.5"
                                        cy="2.5"
                                        r="2.5"
                                        fill="black"
                                      />
                                    </svg>
                                  </span>{" "}
                                  {postedcar.carDetails.transmission}
                                </h6>
                              </Col>
                            </Col>
                            <Col lg="12" className="p-2">
                              <svg
                                width="21"
                                height="21"
                                viewBox="0 0 21 21"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <g clip-path="url(#clip0_434_2834)">
                                  <path
                                    d="M18.3814 8.46854C18.3814 14.3784 10.783 19.444 10.783 19.444C10.783 19.444 3.18457 14.3784 3.18457 8.46854C3.18457 6.45331 3.98512 4.52062 5.4101 3.09564C6.83508 1.67066 8.76777 0.870117 10.783 0.870117C12.7982 0.870117 14.7309 1.67066 16.1559 3.09564C17.5809 4.52062 18.3814 6.45331 18.3814 8.46854Z"
                                    stroke="#333333"
                                    stroke-width="1.71704"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  />
                                  <path
                                    d="M10.7828 11.0014C12.1816 11.0014 13.3156 9.86743 13.3156 8.4686C13.3156 7.06977 12.1816 5.93579 10.7828 5.93579C9.38398 5.93579 8.25 7.06977 8.25 8.4686C8.25 9.86743 9.38398 11.0014 10.7828 11.0014Z"
                                    stroke="#333333"
                                    stroke-width="1.71704"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  />
                                </g>
                                <defs>
                                  <clipPath id="clip0_434_2834">
                                    <rect
                                      width="20.2625"
                                      height="20.2625"
                                      fill="white"
                                      transform="translate(0.651611 0.026001)"
                                    />
                                  </clipPath>
                                </defs>
                              </svg>
                              <span className="m-1" style={{textTransform:"capitalize"}}>Cars 2 Cars Hub, {postedcar.carDetails.city}</span>
                            </Col>
                          </div>
                        </div>
                      </div>
                    ))
                  ) : (
                    <h5 className="text-color text-center m-0 mt-2">
                      Cars Not Found
                    </h5>
                  )}
                </Slider>
              )}
            </Tab.Pane>
            <Tab.Pane eventKey="muv" className="p-3 body_tab">
              {isLoading ? (
                <div className="text-center">
                  <Spinner animation="border" variant="danger" />
                </div>
              ) : (
                <Slider {...QuickSell}>
                  {error == false ? (
                    bodyTypeData.map((postedcar, index) => (
                      <div key={index}>
                        <div className="carousel-slide quick-sell-slide">
                          <div className="col-12 car-details quick-car"  style={{overflow:"hidden",position:"relative"}}>
                          {
                            postedcar.carDetails.city === 'pune'?
                            <div className="inspected_badge" >
                             <div>
                              {/* <FaAward/> */}
                              <Image src={badge} style={{height:"22px"}}/>
                              </div> </div>: ""
                            }
                            <img
                              src={postedcar.carDetails.carImages[0]}
                              alt=""
                              onClick={() =>
                                navigate(
                                  "/SingleCarDetail?carPostId=" +
                                    postedcar.carDetails._id
                                )
                              }
                            />
                            <Col lg="12" className="details">
                              <Col
                                lg="12"
                                className="d-flex justify-content-between"
                              >
                                <Col
                                  lg="10"
                                  onClick={() =>
                                    navigate(
                                      "/SingleCarDetail?carPostId=" +
                                        postedcar.carDetails._id
                                    )
                                  }
                                >
                                  <h5 className="mb-1">
                                    {postedcar.carDetails.brandId}{" "}
                                    {postedcar.carDetails.year}
                                  </h5>
                                  <h6 className="mb-2">
  {`${postedcar.carDetails.model} ${postedcar.carDetails.varient} - ${
    postedcar.carDetails.carNumber
      ? postedcar.carDetails.carNumber.replace(/\s/g, "").substring(0, 4)
      : ""
  }`.substring(0, 20)}
  {`${postedcar.carDetails.model} ${postedcar.carDetails.varient} - ${
    postedcar.carDetails.carNumber
      ? postedcar.carDetails.carNumber.replace(/\s/g, "").substring(0, 4)
      : ""
  }`.length > 20 ? "..." : ""}
</h6>
                                </Col>
                                <Col
                                  lg="1"
                                  className={
                                    localStorage.hasOwnProperty("user")
                                      ? ""
                                      : "d-none"
                                  }
                                >
                                  <WishlistButton
                                    wishlist={postedcar.wishlisted}
                                    uPostId={postedcar.carDetails._id}
                                    userId={userInfo._id}
                                  />
                                </Col>
                              </Col>
                              <Col lg="12">
                                <h6 style={{textTransform:"capitalize"}}>
                                  {(
                                    postedcar.carDetails.kms / 1000
                                  ).toLocaleString("en-US", {
                                    maximumFractionDigits: 1,
                                  }) + "k"}{" "}
                                  km{" "}
                                  <span>
                                    <svg
                                      width="5"
                                      height="5"
                                      viewBox="0 0 5 5"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <circle
                                        cx="2.5"
                                        cy="2.5"
                                        r="2.5"
                                        fill="black"
                                      />
                                    </svg>
                                  </span>{" "}
                                  <span className="text-capitalize">
                                    {postedcar.fuelType}
                                  </span>{" "}
                                  <span>
                                    <svg
                                      width="5"
                                      height="5"
                                      viewBox="0 0 5 5"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <circle
                                        cx="2.5"
                                        cy="2.5"
                                        r="2.5"
                                        fill="black"
                                      />
                                    </svg>
                                  </span>{" "}
                                  {postedcar.carDetails.transmission}
                                </h6>
                              </Col>
                            </Col>
                            <Col lg="12" className="p-2">
                              <svg
                                width="21"
                                height="21"
                                viewBox="0 0 21 21"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <g clip-path="url(#clip0_434_2834)">
                                  <path
                                    d="M18.3814 8.46854C18.3814 14.3784 10.783 19.444 10.783 19.444C10.783 19.444 3.18457 14.3784 3.18457 8.46854C3.18457 6.45331 3.98512 4.52062 5.4101 3.09564C6.83508 1.67066 8.76777 0.870117 10.783 0.870117C12.7982 0.870117 14.7309 1.67066 16.1559 3.09564C17.5809 4.52062 18.3814 6.45331 18.3814 8.46854Z"
                                    stroke="#333333"
                                    stroke-width="1.71704"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  />
                                  <path
                                    d="M10.7828 11.0014C12.1816 11.0014 13.3156 9.86743 13.3156 8.4686C13.3156 7.06977 12.1816 5.93579 10.7828 5.93579C9.38398 5.93579 8.25 7.06977 8.25 8.4686C8.25 9.86743 9.38398 11.0014 10.7828 11.0014Z"
                                    stroke="#333333"
                                    stroke-width="1.71704"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  />
                                </g>
                                <defs>
                                  <clipPath id="clip0_434_2834">
                                    <rect
                                      width="20.2625"
                                      height="20.2625"
                                      fill="white"
                                      transform="translate(0.651611 0.026001)"
                                    />
                                  </clipPath>
                                </defs>
                              </svg>
                              <span className="m-1" style={{textTransform:"capitalize"}}>Cars 2 Cars Hub, {postedcar.carDetails.city}</span>
                            </Col>
                          </div>
                        </div>
                      </div>
                    ))
                  ) : (
                    <h5 className="text-color text-center m-0 mt-2">
                      Cars Not Found
                    </h5>
                  )}
                </Slider>
              )}
            </Tab.Pane>
          </Tab.Content>
        </Col>
      </Row>
    </Tab.Container>
  );
}

export default BodyType;
